// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d239a4a6","703":"0d96d7b3","787":"d77857a7"}[chunkId] + ".chunk.js";
};